import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';

import Date from '../../../common/date';
import Time from '../../../common/Time';
import Modal from '../../../common/Modal';
import CancelButton from '../../../common/buttons/cancelButton';

const OrderInfoItemTitle = ({
  item,
  qtyInput,
  onQtyInputChange,
  onSaveQty,
  canSave,
  qtyModalIsOn,
  qtyModalOff,
  qtyModalOn,
}) => {
  if (item.start) {
    return <span>1 &times; {item.description} <Date>{item.start}</Date> <Time>{item.start}</Time></span>;
  }
  return (
    <React.Fragment>
      <button className="c-order-item__qty-button" onClick={qtyModalOn}>
        <span className="u-fontsize-extrasmall">{item.quantity} &times; {item.name}</span>
      </button>
      <Modal
        className="u-width-400 u-min-width-280 u-max-width-100"
        showCloseButton
        display-if={qtyModalIsOn}
        close={qtyModalOff}
        title={item.name}
      >
        <div className="u-p">
          <div className="c-label-new">{t('register:sale.order_info_item_title.enter_custom_amount')}</div>
          <input
            className="c-input"
            type="number"
            value={qtyInput}
            onChange={onQtyInputChange}
          />
          <div className="layout__item u-text-right u-mt u-mb0">
            <CancelButton content={t('register:sale.order_info_item_title.close')} onClick={qtyModalOff} />
            <button className="c-btn u-width-120 u-ml--" type="button" onClick={onSaveQty} disabled={!canSave}>
              <span className="c-btn__text">{t('register:sale.order_info_item_title.update')}</span>
            </button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

OrderInfoItemTitle.propTypes = {
  item: PropTypes.object.isRequired,
  qtyInput: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onQtyInputChange: PropTypes.func.isRequired,
  onSaveQty: PropTypes.func.isRequired,
  canSave: PropTypes.bool.isRequired,
  qtyModalIsOn: PropTypes.bool.isRequired,
  qtyModalOff: PropTypes.func.isRequired,
  qtyModalOn: PropTypes.func.isRequired,
};

OrderInfoItemTitle.defaultProps = {
  qtyInput: '',
};

export default OrderInfoItemTitle;
